import { useTranslations } from '@aikoa/i18n/react'
import { useMemo } from 'react'
import { View } from 'react-native'
import Icon from '~/components/Icon.tsx'
import { Avatar, AvatarFallback, AvatarImage } from '~/components/ui/avatar.tsx'
import { Text } from '~/components/ui/text.tsx'
import { useSession } from '~/components/user/SessionProvider.tsx'
import { useUserProfile } from '~/data/user/userProfile.ts'
import { cn } from '~/lib/utils.ts'

export function UserButton({
  className,
  showName = true,
  avatarClassName,
}: {
  className?: string
  avatarClassName?: string
  showName?: boolean
}) {
  const { t } = useTranslations('common')
  const { data: userProfile } = useUserProfile()
  const { session, isAnonymous } = useSession()

  const currentAvatarUrl = useMemo(() => userProfile?.data?.avatar_url, [userProfile])

  if (!session?.user || isAnonymous) {
    return null
  }

  const userName = userProfile?.name || session?.user?.email || ''

  return (
    <View className={cn('flex-row items-center justify-start gap-4 rounded-full p-4', className)}>
      <Avatar
        className={cn('size-12 border border-tertiary-foreground', avatarClassName)}
        // eslint-disable-next-line i18next/no-literal-string
        alt="User avatar">
        <AvatarImage source={{ uri: currentAvatarUrl }} />
        <AvatarFallback className="bg-tertiary-foreground">
          <Icon name="person-outline" size={20} className="text-primary" />
        </AvatarFallback>
      </Avatar>
      <View>
        {showName && userName ? (
          <Text
            className={cn(
              'font-normal text-lg text-tertiary-foreground transition-colors duration-150 group-hover:text-accent group-active:text-accent'
            )}>
            {userName}
          </Text>
        ) : (
          <Text
            className={cn(
              'font-normal text-lg text-tertiary-foreground transition-colors duration-150 group-hover:text-accent group-active:text-accent'
            )}>
            {t(($) => $.user.myAccount)}
          </Text>
        )}
      </View>
    </View>
  )
}
